import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { IItem, ITEM_TTL_ES } from '../../item.interface';
import { ItemService } from '../../item.service';

@Component({
  selector: 'pg-item-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ItemSelectComponent extends SelectTemplate {
  constructor(private serviceBase: ItemService) {
    super(ITEM_TTL_ES, serviceBase);
  }

  async ngOnInit() {
    this.table.settings = {
      title: ITEM_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Descripción', field: 'name' },
        { header: 'Principio Activo', field: 'activesIngredients' },
        { header: 'Grupo Terapéutico', field: 'therapistGroups' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IItem[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
